import {Component, EventEmitter, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import {ModalidadeScrService} from '../modalidade-scr.service';
import {ModalidadeScrModel, ObjetivoFinanciamento, ObjetivoFinanciamentoLista} from '../../../model/modalidade-scr.model';
import { MessageChannelService, messageLevel } from '@bndes/bndes-ux4/bndes-angular-utils';

@Component({
  selector: 'app-modalidade-scr',
  templateUrl: './modalidade-scr-pesquisa.html',
  standalone: false
})
export class ModalidadeScrPesquisa implements OnInit {

  protected pesquisaForm: UntypedFormGroup = null;
  public pesquisado: boolean = false;
  public listaTodasModalidades: ModalidadeScrModel[] = [];
  public listaTipos: ObjetivoFinanciamento[] = ObjetivoFinanciamentoLista;
  public modalidadesNoScr: ModalidadeScrModel[] = [];

  constructor(private servico: ModalidadeScrService,
              private formBuilder: UntypedFormBuilder,
            private messageService: MessageChannelService,) {
  }

  ngOnInit() {
    this.pesquisaForm = this.createReactiveForm();

    this.servico.listarHabilitados().subscribe(res => {
      this.listaTodasModalidades = res;
    });
  }

  desabilitarCodigoModalidade(codigo: number) {
    if (codigo) {
      this.servico.desabilitar(codigo).subscribe({
        next: this.handleUpdateResponse.bind(this),
        error: this.handleError.bind(this),
      })
    }
  }

  handleUpdateResponse(data: any) {
    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: 'Código de modalidade excluído com sucesso'
    })
    this.buscar();
  }

  handleError(data: any) {
    console.log('Error', data);
    this.messageService.addMessage({
        title: 'error',
        type: 'CRUD_OPERATION',
        level: messageLevel.ERROR,
        message: 'Erro ao tentar excluir código de modalidade SCR.'
      });
  }

  buscar() {
    this.servico.listarTodosFiltrados(this.obterFiltrosBusca()).subscribe(res => {
      this.modalidadesNoScr = res;
      this.pesquisado = true;
    });
  }

  obterFiltrosBusca() {
    let dadosPreenchidos: any = {};
    const form = this.pesquisaForm.value;

    if (form.codigoScrModalidade) {
      dadosPreenchidos.codigoScrModalidade = form.codigoScrModalidade;
    }

    if (form.tipoScrModalidade) {
      dadosPreenchidos.tipoScrModalidade = form.tipoScrModalidade;
    }

    return dadosPreenchidos;
  }


  limpar() {
    this.pesquisaForm.reset({
      codigoScrModalidade: null,
      tipoScrModalidade: null
    });
    this.pesquisado = false;
    this.modalidadesNoScr = [];
  }

  createReactiveForm(): UntypedFormGroup {

    const f = this.formBuilder.group({
      codigoScrModalidade: null,
      tipoScrModalidade: null,
    });

    return f;
  }
}
